import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { App, NavParams, PopoverController, ModalController, AlertController, LoadingController } from 'ionic-angular';
import { Log, LogType, LogMessage, LogMessageType, Activity, Project } from 'api/models';
import { LogMessages, Activities, Logs, Users } from 'api/collections';
import { MeteorObservable } from 'meteor-rxjs';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subscription, Observable, Subscriber } from 'rxjs';
import { PictureService } from '../../services/picture';
import { ShowPictureComponent } from '../show-picture/show-picture';
import { ISDEV } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'log-messages-page',
  templateUrl: 'log-messages.html'
})
export class LogMessagesPage implements OnInit, OnDestroy {
public isDev = ISDEV;
  logId: string;
  log: Log;
  projectTitle: String;
  logType: LogType;
  title: string;
  picture: string;
  creatorName: string;
  createdAt: Date;

  logMessagesDayGroups;

  logMessage: string = '';
  lastSentMessage: string = '';

  autoScroller: MutationObserver;
  scrollOffset = 0;
  senderId: string;
  loadingLogMessages: boolean;

  logMessagesComputation: Subscription;

  logMessagesBatchCounter: number = 0;

  constructor(
    navParams: NavParams,
    public appCtrl: App,
    private el: ElementRef,
    private popoverCtrl: PopoverController,
    private pictureService: PictureService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public httpService: HttpService,
    public loadingCtrl: LoadingController,
    public authenticationService: AuthenticationService,
    private sharedService: SharedService,
  ) {
    this.logId = <string>navParams.get('logId');
    this.senderId = this.authenticationService.MeteorUserId();
  }

  private get logMessagesPageContent(): Element {
    return this.el.nativeElement.querySelector('.log-messages-page-content');
  }

  private get logMessagesList(): Element {
    return this.logMessagesPageContent.querySelector('.log-messages');
  }

  private get scroller(): Element {
    return this.logMessagesList.querySelector('.scroll-content');
  }

  async mainLoop(){
    if (!this.logId) {
      return;
    }
    this.log = Logs.collection.findOne(this.logId);
    let creatorName;
    if (this.log) {
      this.logType = this.log.logType;
      this.title = this.log.title;
      this.picture = this.log.picture;
      if (this.log.creatorId) {
        const creatorUser = Users.findOne(this.log.creatorId);
        if (creatorUser && creatorUser.profile) {
          creatorName = creatorUser.profile.name;
        }
      }
      if (this.log.createdAt) {
        this.createdAt = this.log.createdAt;
      }
    }
    this.creatorName = creatorName || '';

    
  }

  ngOnInit() {
    this.autoScroller = this.autoScroll();

    // Get total messages count in database so we can have an indication of when to
    // stop the auto-subscriber
    /*
    MeteorObservable.call('countLogMessages', this.logId).subscribe((logMessagesCount: number) => {
      Observable
      // Chain every scroll event
      .fromEvent(this.scroller, 'scroll')
      // Remove the scroll listener once all messages have been fetched
      .takeUntil(this.autoRemoveScrollListener(logMessagesCount))
      // Filter event handling unless we're at the top of the page
      .filter(() => !this.scroller.scrollTop)
      // Prohibit parallel subscriptions
      .filter(() => !this.loadingLogMessages)
      // Invoke the messages subscription once all the requirements have been met
      .forEach(() => this.subscribeLogMessages());
    });
    */

    try {
      this.httpService.MeteorCall('countLogMessages', this.logId).then((logMessagesCount: any) => {
        Observable
        // Chain every scroll event
        .fromEvent(this.scroller, 'scroll')
        // Remove the scroll listener once all messages have been fetched
        .takeUntil(this.autoRemoveScrollListener(logMessagesCount))
        // Filter event handling unless we're at the top of the page
        .filter(() => !this.scroller.scrollTop)
        // Prohibit parallel subscriptions
        .filter(() => !this.loadingLogMessages)
        // Invoke the messages subscription once all the requirements have been met
        .forEach(() => this.subscribeLogMessages());
        return this.httpService.privateLoopAction(true);
      })
      .catch(err => console.log('meteor call error:', err))
      .then(async ()=>{
        await this.httpService.MeteorSubscribe('logDetails', this.logId)
            .then(() => this.httpService.MeteorSubscribe('logMessages', this.logId))
            .then(()=>this.httpService.privateLoopAction(true));


        MeteorObservable.autorun().subscribe(async () => {
          this.mainLoop();
          this.logMessagesDayGroups = await this.findLogMessagesDayGroups();
        });
       
        this.mainLoop();
        this.logMessagesDayGroups = await this.findLogMessagesDayGroups();
      });
    } catch (e) {
      console.log('meteor call error:', e);
    }

    //get log information from api
    // try{
    //   setInterval(async ()=>{
    //     try{
    //       this.logMessagesDayGroups = await this.findLogMessagesDayGroups()
    //     }catch(err){}
    //   }, 1000)
    // }catch(err){}
  }

  ngOnDestroy() {
    this.autoScroller.disconnect();
  }

  // Subscribes to the relevant set of messages
  subscribeLogMessages(): void {
    // A flag which indicates if there's a subscription in process
    this.loadingLogMessages = true;
    // A custom offset to be used to re-adjust the scrolling position once
    // new dataset is fetched
    this.scrollOffset = this.scroller.scrollHeight;

    /*
    MeteorObservable.subscribe('logTextMessages',
      this.logId,
      ++this.logMessagesBatchCounter
    ).subscribe(() => {
      // Keep tracking changes in the dataset and re-render the view
      if (!this.logMessagesComputation) {
        this.logMessagesComputation = this.autorunLogMessages();
      }
      // Allow incoming subscription requests
      this.loadingLogMessages = false;
    });
    */

    this.httpService.MeteorSubscribe(
      'logTextMessages',
      this.logId,
      ++this.logMessagesBatchCounter
    );
    // Keep tracking changes in the dataset and re-render the view
    if (!this.logMessagesComputation) {
      this.logMessagesComputation = this.autorunLogMessages();
    }
    // Allow incoming subscription requests
    this.loadingLogMessages = false;
  }

  // Detects changes in the messages dataset and re-renders the view
  autorunLogMessages(): Subscription {
    return MeteorObservable.autorun().subscribe(async () => {
      this.logMessagesDayGroups = await this.findLogMessagesDayGroups();
    });
  }

  // Removes the scroll listener once all messages from the past were fetched
  autoRemoveScrollListener<T>(logMessagesCount: number): Observable<T> {
    return Observable.create((observer: Subscriber<T>) => {
      LogMessages.find({type: LogMessageType.TEXT}).subscribe({
        next: async (logMessages) => {
          // Once all messages have been fetched
          if (logMessagesCount !== logMessages.length) {
            return;
          }
          for(const i in logMessages){
            logMessages[i].content=logMessages[i].content?await this.authenticationService.imageConverter(logMessages[i].content):logMessages[i].content
          }
          // Signal to stop listening to the scroll event
          observer.next();

          // Finish the observation to prevent unnecessary calculations
          observer.complete();
        },
        error: (e) => {
          observer.error(e);
        }
      });
    });
  }

  async findLogMessagesDayGroups() {
    const format = 'D MMMM Y';

    let logMessages= LogMessages.find({
      logId: this.logId,
      type: LogMessageType.TEXT,
    }, {
      sort: { createdAt: 1 }
    }).fetch()
      .map((logMessage: LogMessage) => {
        // Compose missing data that we would like to show in the view
          // logMessage.ownership = this.senderId == logMessage.senderId ? 'mine' : 'other';
          logMessage.senderName = _.get(Users.findOne(logMessage.senderId), 'profile.name');
          return logMessage;
        });

        // Group by creation day
        let groupedLogMessages:any = _.groupBy(logMessages, (logMessage) => {
          return moment(logMessage.createdAt).format(format);
        });
        // Transform dictionary into an array since Angular's view engine doesn't know how
        // to iterate through it
        groupedLogMessages= Object.keys(groupedLogMessages).map((timestamp: string) => {
          return {
            timestamp: timestamp,
            logMessages: groupedLogMessages[timestamp],
            today: moment().format(format) === timestamp
          };
        });
      // for(const i in groupedLogMessages){
      //   groupedLogMessages[i].content=groupedLogMessages[i].content?await this.authenticationService.imageConverter(groupedLogMessages[i].content):groupedLogMessages[i].content
      // }
      return groupedLogMessages;
  }

  autoScroll(): MutationObserver {
    const autoScroller = new MutationObserver(this.scrollDown.bind(this));

    autoScroller.observe(this.logMessagesList, {
      childList: true,
      subtree: true
    });

    return autoScroller;
  }

  scrollDown(): void {
    // Don't scroll down if messages subscription is being loaded
    if (this.loadingLogMessages) {
      return;
    }

    // Scroll down and apply specified offset
    this.scroller.scrollTop = this.scroller.scrollHeight - this.scrollOffset;
    // Zero offset for next invocation
    this.scrollOffset = 0;
  }

  onInputKeypress({ keyCode }: KeyboardEvent): void {
    if (keyCode === 13) {
      this.sendLogTextMessage();
    }
  }

  sendLogTextMessage(): void {
   if(this.isDev == true) {  console.log("sending message", this.logMessage) }
    // If message was yet to be typed, abort
    if (!this.logMessage || !this.logMessage.length) {
      console.log("not sending, no message");
      return;
    }

    if(this.lastSentMessage===this.logMessage){
      this.logMessage="";
      return;
    }
    this.lastSentMessage=this.logMessage;
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    this.httpService.MeteorCall(
      'addLogMessage',
      LogMessageType.TEXT,
      this.log._id,
      this.logMessage
    ).then(async () => {
       // Zero the input field
       this.logMessage = '';
       this.lastSentMessage='';
       await this.httpService.refreshSubscriptions();
       loader.dismiss();
    })
    .catch((e: Error) => {
      console.log('meteor call error', e);
      loader.dismiss();
    });
  }

  sendPictureMessage(blob: File): void {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    this.pictureService.upload(blob).then((picture) => {
      this.httpService.MeteorCall(
        'addLogMessage',
        LogMessageType.PICTURE,
        this.log._id,
        picture.url
      ).then(async () => {
        await this.httpService.refreshSubscriptions();
        loader.dismiss();
      })
      .catch((e: Error) => {
        console.log('meteor call error:', e);
      });
    });
  }

  async showPicture(logMessage: LogMessage, { target }: Event) {
    const modal = this.modalCtrl.create(ShowPictureComponent, {
      logMessageId: logMessage._id,
      pictureSrc: await this.authenticationService.imageConverter((<HTMLImageElement>target).src)
    });

    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/log-messages/log-messages.ts